import React, { useState } from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (1).png'

function CarbonIncentive() {
  const [activeTab, setActiveTab] = useState('measurement')

  const carbonData = {
    measurement: [
      {
        title: "Carbon credit:",
        description: "A tradable certificate or permit representing the right to emit one ton of carbon dioxide or its equivalent. Carbon credits are often generated by projects that reduce or remove greenhouse gas emissions, and they can be bought and sold on the carbon market."
      },
      {
        title: "Credit issued:",
        description: "The formal recognition and issuance of carbon credits or other environmental certificates to a project that has successfully reduced or removed greenhouse gas emissions, as verified and validated by relevant authorities."
      },
      {
        title: "Carbon certification programme:",
        description: "A structured program that certifies and validates the environmental performance of projects, initiatives, or organizations in terms of their greenhouse gas emission reductions or sustainability practices."
      },
      {
        title: "Voluntary carbon credit:",
        description: "Tradable certificates representing a reduction or removal of greenhouse gas emissions that are not legally mandated. Individuals or organizations purchase voluntary carbon credits to offset their own emissions or support environmental projects."
      },
      {
        title: "Compliance carbon credit:",
        description: "Tradable certificates representing a reduction or removal of greenhouse gas emissions in compliance with legally mandated emission reduction targets or regulatory requirements."
      }
    ],
    tracking: [
      {
        title: "Emission monitoring:",
        description: "Continuous measurement and recording of greenhouse gas emissions from various sources to track progress and ensure compliance with environmental standards."
      },
      {
        title: "Data verification:",
        description: "The process of validating and confirming the accuracy of emission data through independent third-party audits and quality assurance procedures."
      },
      {
        title: "Performance metrics:",
        description: "Key performance indicators used to evaluate the effectiveness of emission reduction strategies and environmental initiatives."
      },
      {
        title: "Reporting standards:",
        description: "Standardized frameworks and guidelines for reporting greenhouse gas emissions and environmental performance to stakeholders and regulatory bodies."
      },
      {
        title: "Continuous improvement:",
        description: "Ongoing process of analyzing emission data to identify opportunities for further reduction and optimization of environmental performance."
      }
    ]
  }

  const CarbonItem = ({ title, description, index }) => {
    const delay = index * 50 // Staggered animation
    
    return (
      <div 
        className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px] animate-fadeIn"
        style={{ animationDelay: `${delay}ms` }}
      >
        <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
          {title}
        </h3>
        <p className="w-full font-normal text-[16px] leading-[150%] text-[#141414]">
          {description}
        </p>
      </div>
    )
  }

  return (
    <>
      <Header/>
      <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
        {/* Text Section */}
        <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
          <h1 className="w-full max-w-[688px] h-[76px] font-['SF_Pro_Display'] font-medium text-6xl leading-[76px] text-center text-[#141414]">
            Measurement & Tracking
          </h1>
        </div>

        {/* Image Section */}
        <img 
          className="absolute w-full h-[552px] top-[275px] rounded-2xl object-cover"
          src={Glossary}
          alt="Carbon Incentive"
        />
      </div>

      <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
        {/* Tab Buttons */}
        <div className="flex gap-4 border-b border-gray-200 w-full">
          <button
            onClick={() => setActiveTab('measurement')}
            className={`px-6 py-3 text-lg font-medium transition-all duration-150 ${
              activeTab === 'measurement'
                ? 'text-[#0D924F] border-b-2 border-[#0D924F]'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Measurement
          </button>
          <button
            onClick={() => setActiveTab('tracking')}
            className={`px-6 py-3 text-lg font-medium transition-all duration-150 ${
              activeTab === 'tracking'
                ? 'text-[#0D924F] border-b-2 border-[#0D924F]'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Tracking
          </button>
        </div>

        {/* Tab Content with Instant Animation */}
        <div className="flex flex-col gap-6 w-full">
          {carbonData[activeTab].map((item, index) => (
            <CarbonItem 
              key={index}
              index={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
      <Footer/>
    </>
  )
}

export default CarbonIncentive